export const NEWS_TEASER_COUNT = 3;
export const PLAUSCH_TEASER_COUNT = 2;
export const EVENTS_TEASER_COUNT = 2;
export const MARKT_OFFER_TEASER_COUNT = 4;
export const MARKT_SEEKING_TEASER_COUNT = 4;
